// extracted by mini-css-extract-plugin
export var autoExpand = "_23-b";
export var container = "_23-a";
export var containerWidth = "_23-8";
export var disabled = "_23-2";
export var error = "_23-3";
export var fullWidth = "_23-9";
export var highlightContainer = "_23-5";
export var inputWrapper = "_23-0";
export var small = "_23-1";
export var textarea = "_23-4";
export var validatedTextarea = "_23-6";
export var visuallyHidden = "_23-7";